import { render, staticRenderFns } from "./modal-link.vue?vue&type=template&id=89361ac0"
import script from "./modal-link.vue?vue&type=script&lang=js"
export * from "./modal-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/_base/modal-link/africa/modal-link.vue
// module id = MbgJ
// module chunks = 37